import { Button, Card, Col, Row, Table, Typography } from "antd";

import { GiftOutlined, DownOutlined, MobileOutlined } from "@ant-design/icons";
import React from "react";
import { useTheme } from "../../../../shared-components/Styles/ThemeHook";
import { CardCEEE, PaymentMethods } from "../components";
import { PricingCards } from "../../../../shared-components/Components/Pricing/PricingCards/web";
import { PricingTable } from "../../../../shared-components/Components/Pricing/PricingTable/web";
import { ImagenOptimizada } from "../../../../shared-components/Components/Image/web";

const { Title, Text } = Typography;

export const ComparativeTable = () => {
	const data = [
		{
			"1": "Precio",
			"2": "U$S 80",
			"3": "U$S 125",
			"4": "U$S 125",
			"5": "U$S 150",
		},
	];
	const columns = [
		{
			title: <Title level={2}>{"Comparación de Planes"}</Title>,
			children: [
				{
					title: null,
					dataIndex: "1",
					key: "1",
				},
				{
					title: <Text strong>{"Plan Clásico"}</Text>,
					dataIndex: "2",
					key: "2",
				},
				{
					title: <Text strong>{"Plan Baja temporada"}</Text>,
					dataIndex: "3",
					key: "3",
				},
				{
					title: <Text strong>{"Plan Pro"}</Text>,
					dataIndex: "4",
					key: "4",
				},
				{
					title: <Text strong>{"Plan Full"}</Text>,
					dataIndex: "5",
					key: "5",
				},
			],
		},
	];

	return <Table dataSource={data} columns={columns} pagination={false} bordered={false} />;
};

export const YourPublication = (): JSX.Element => {
	const { theme } = useTheme();

	return (
		<Row justify="center">
			<Col span={24} sm={16} lg={16}>
				<Row
					justify="center"
					className="publication-content"
					gutter={[theme.spacing.lgSpacing, 0]}>
					<Col span={24} lg={6}>
						<div className="gift-align">
							<div className="gift-icon">
								<GiftOutlined style={{ color: "white", fontSize: 75 }} />
							</div>
						</div>
					</Col>
					<Col span={24} lg={18}>
						<div className="publication">
							<Title level={3} className="publication-title-sub text-gray">
								{"Publicando con cualquier plan" + ":"}
							</Title>
							<Title level={2} className="publication-title">
								{"¡Tu publicación 2x1!"}
							</Title>
							<Title level={3} className="publication-title-sub">
								{"Tu aviso va a los 2 portales por el precio de 1."}
							</Title>
						</div>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};

export const RentProperty = ({ onClick }) => {
	const { theme } = useTheme();

	return (
		<Row justify="end">
			<Col span={24} sm={10} lg={10} style={{ paddingBottom: theme.spacing.xlSpacing }}>
				<CardCEEE
					subtitle={"Esta temporada..."}
					title={"¡Alquilá tu propiedad con los mejores!"}
					body={
						<Text strong>{"Se unen para brindarte los mejores resultados"}</Text>
					}
					buttonSettings={{
						className: "primary",
						type: "primary",
						href: "#",
						id: "publicar",
						children: "Publicar",
						onClick: onClick,
					}}
				/>
			</Col>
			<Col span={24}>
				<Card bordered={false} className="card-doubts">
					<Row justify="center">
						<Col span={2} className="icon">
							<MobileOutlined style={{ color: "white", fontSize: 36 }} />
						</Col>
						<Col span={16} className="call-us">
							<div className="">{"¿Tenés dudas?"}</div>
							<div className="phone">
								{"Llamanos al"}{" "}
								<a href={"tel:" + "097000222"}>{"097 000 222"}</a>
							</div>
						</Col>
					</Row>
				</Card>
			</Col>
		</Row>
	);
};

export const PricingCardSection = ({ cards, scrollToTable }) => {
	const { theme } = useTheme();

	return (
		<Row gutter={[0, theme.spacing.lgSpacing]} justify={"center"}>
			<Col span={24} style={{ textAlign: "center" }}>
				<Title level={2}>{"¡Empezá a publicar hoy!"}</Title>
				<Text>{"Seleccioná un plan para continuar"}</Text>
			</Col>
			<Col span={24}>
				<PricingCards data={cards} />
			</Col>
			<Col>
				<Button icon={<DownOutlined />} shape={"circle"} onClick={scrollToTable} />
			</Col>
		</Row>
	);
};

export const TableSection = ({ table }) => {
	const { theme } = useTheme();

	return (
		<Row gutter={[0, theme.spacing.lgSpacing]}>
			<Col span={24} style={{ textAlign: "center" }}>
				<Title level={2}>{"Comparación de planes"}</Title>
			</Col>
			<Col span={24}>
				<PricingTable dataSource={table.data} rowItems={table.rowsItems} />
			</Col>
		</Row>
	);
};

export const PaymentMethodSection = ({ scrollToDoubts }) => {
	const { theme } = useTheme();

	return (
		<Row justify={"center"} gutter={[0, theme.spacing.xlSpacing]}>
			<Col span={24} style={{ textAlign: "center" }}>
				<Text type={"secondary"}>{"Métodos de pago" + ":"}</Text>
			</Col>
			<Col span={24}>
				<PaymentMethods />
			</Col>
			<Col>
				<Button icon={<DownOutlined />} shape={"circle"} onClick={scrollToDoubts} />
			</Col>
		</Row>
	);
};

export const DoubtsSection = () => {
	const { theme } = useTheme();

	return (
		<Row
			align={"middle"}
			justify={"center"}
			gutter={[0, theme.spacing.xlSpacing]}
			style={{ flexWrap: "wrap", height: "100%" }}>
			<Col span={24} style={{ textAlign: "center" }}>
				<Title level={1}>
					{"¿Tenés dudas?"}
					<br />
					{"¿No sabés cuál es el mejor producto para vos?"}
				</Title>
				<Title level={3}>
					{"¡Tenemos todas las opciones para que tengas una excelente temporada!"}
				</Title>
			</Col>
			<Col>
				<Row align={"middle"} gutter={[theme.spacing.xlSpacing, theme.spacing.lgSpacing]}>
					<Col flex={"60px"}>
						<MobileOutlined />
					</Col>
					<Col flex={1}>
						<Title level={2}>{"Llamanos al "}</Title>
						<a href={"tel:" + "097000222"}>
							<Title level={2} style={{ fontWeight: "bold" }}>
								{"097 000 222"}
							</Title>
						</a>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<ImagenOptimizada
					className="img"
					src="https://cdn2.infocasas.com.uy/web/5ee3783c04087_infocdn__footer-publicacion-temporales@2x.png"
					alt={"Publicación temporal"}
				/>
			</Col>
		</Row>
	);
};
